import FeedView from '@/components/feed/feed';

export default function Feed() {
    return <FeedView />;
}
